// extracted by mini-css-extract-plugin
export default {"page":"KRRm1UtXMyXsqnXgpFhL","profilelist":"U4lVH4R96au8SV9s8r1Q","digitfocus":"d1rWIgxZN_6ZepHXzqtR"};